import { FC } from "react";

interface PDRViewerProps {
    pdfDocument: string ; 
}

export const PDFViewer = ({pdfDocument} : PDRViewerProps) => {
    return (
      
        <embed src={pdfDocument} type="application/pdf" width="100%" height="1000px" />

    );
  }
  export default PDFViewer;